import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { AdultoAv } from "../../../components/AdultoAv/AdultoAv";
import { useConfig } from "../../../providers/useConfig";
import styles from "./SyncAvWidgets.module.scss";
export const AvMethodsComponents = {
    adulto_cz_av: AdultoAv,
};
export const SyncAvWidgets = ({ selectedMethod, onAvFinished }) => {
    const SyncAvComponent = AvMethodsComponents[selectedMethod];
    const config = useConfig();
    const scriptConfig = config.AGE_VERIFICATION_ASYNC_SCRIPTS_CONFIG?.find((syncScriptConfig) => syncScriptConfig.code === selectedMethod);
    const scriptLink = scriptConfig?.scriptUrl;
    const scriptKey = scriptConfig?.scriptKey;
    const isComponentShown = SyncAvComponent && scriptLink && scriptKey;
    return (_jsx("div", { className: classNames({
            [styles.hiddenComponent]: !isComponentShown,
        }), "data-testid": "syncAvWidget", children: isComponentShown && _jsx(SyncAvComponent, { scriptLink: scriptLink, scriptKey: scriptKey, onAvFinish: onAvFinished }) }));
};
//# sourceMappingURL=SyncAvWidgets.js.map